import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import { Grid } from '@mui/material'
import { connect } from 'react-redux'
import * as Redux from 'redux'
import { CommonService } from '@Services/common.service'
import { Controller } from 'react-hook-form'
import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import { FormService } from '@Services/form.service'
import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import UploadImage from '@Components/Form/UploadImage/UploadImage'
import { useEffect } from 'react'
import { RegroundTypes } from '@Stores/client/client.action-types'
import { ICommonQuery } from '@Models/common.model'
import RegroundAction from '@Stores/client/actions/reground.action'
import { EClassifications } from '@Enum/classifications.enum'
import ClassificationAction from '@Stores/client/actions/classification.action'
import UploadFiles from '@Components/UploadFile/UploadFiles'

interface IPartsForm {
    control: any
    errors: any
    watch?: any
    reset?: any
    imageChanged: (e: string, type: string) => void
    fileChanged: (e: string, type: string) => void
    onRemoveImg: (type: string) => void
    removeFileUpload: (type: string) => void
    getComponents?: () => void
    setValue?: any
    isDetailPage?: boolean
    isDisabled?: boolean
    isClearPartForm?: boolean
    productDetail?: any
    cities?: []
    states?: []
    components?: []
    getStates?: any
    getCities?: any
}

const PartsForm = (props: IPartsForm) => {
    const {
        control,
        errors,
        watch,
        reset,
        imageChanged,
        onRemoveImg,
        fileChanged,
        removeFileUpload,
        getComponents,
        setValue,
        isDisabled,
        isDetailPage,
        isClearPartForm,
        productDetail,
        getStates,
        getCities,
        cities,
        states,
        components,
    } = props
    const ac = new AbortController()
    const watchPartProduct = watch('partProduct')
    const watchPartSeller = watch('partSeller')

    const handleSelectChange = (
        value: any,
        type: string,
        isCreatePage = true
    ) => {
        switch (type) {
            case 'STATE': {
                if (isCreatePage) setValue('partSeller.city', null)

                const params = {
                    parentCode: value,
                }
                getCities(params)
                break
            }
            default:
                break
        }
    }
    useEffect(() => {
        getStates({ codes: 'CALIFORNIA' })
        getCities(watchPartSeller?.state)
        if (getComponents) getComponents()
        if (isClearPartForm) {
            setValue('partProduct', {
                component: null,
                serial: '',
            })
            setValue('partSeller', {
                file: {
                    id: '',
                    name: '',
                    url: '',
                },
                ffl: '',
                businessName: '',
                address: '',
                city: null,
                state: null,
                zipCode: '',
                loading: false,
                dateOfPurchase: null,
            })
        }
        return () => {
            ac.abort()
        }
    }, [])

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item sm={4} xs={12}>
                    <UploadImage
                        className="w-100 mb-2"
                        style={{ height: 174 }}
                        fileChanged={(e) => {
                            imageChanged(e, 'PART')
                        }}
                        imageUrl={watchPartProduct?.imageUrl}
                        isLoading={watchPartProduct?.loading}
                        type="upload-profile"
                        id="upload-part-image"
                        disabled={isDisabled}
                        remove
                        removeAction={() => onRemoveImg('PART')}
                    />
                </Grid>
                <Grid item sm={8} xs={12} container spacing={2}>
                    <Grid item sm={6} xs={12}>
                        <Controller
                            control={control}
                            name="partProduct.component"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <BaseCreatableSelect
                                    label="Component"
                                    options={components}
                                    value={value}
                                    onChange={(event: any) => {
                                        onChange(event)
                                    }}
                                    fullWidth
                                    error={
                                        errors?.partProduct?.component && true
                                    }
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'partProduct.component',
                                        'Component'
                                    )}
                                    disabled={isDisabled}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                        <Controller
                            control={control}
                            name="partProduct.serial"
                            defaultValue=""
                            rules={{ required: true }}
                            render={({
                                field: { ref, value, onChange, ...field },
                            }: any) => (
                                <RedditTextField
                                    {...field}
                                    value={value}
                                    onChange={onChange}
                                    disabled={isDisabled}
                                    label="Serial #"
                                    className="reddit-input w-100"
                                    variant="filled"
                                    onKeyPress={(e: any) =>
                                        CommonService.allowsInput(e, [
                                            'alphabet',
                                            'numeric',
                                        ])
                                    }
                                    error={errors?.partProduct?.serial && true}
                                    helperText={FormService.getErrorMessage(
                                        errors,
                                        'partProduct.serial',
                                        'serial'
                                    )}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <p className="page-title mt-5 w-100">Seller Details</p>
            <Grid container spacing={2}>
                <Grid item sm={6} xs={12} className="pt-2">
                    <Controller
                        control={control}
                        name="partSeller.ffl"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                label="FFL #"
                                className="reddit-input w-100"
                                variant="filled"
                                disabled={isDisabled}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'space',
                                        'numeric',
                                    ])
                                }
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    <Controller
                        control={control}
                        name="partSeller.businessName"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                label="Business Name"
                                className="reddit-input w-100"
                                variant="filled"
                                disabled={isDisabled}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'space',
                                        'numeric',
                                    ])
                                }
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    <Controller
                        control={control}
                        name="partSeller.dateOfPurchase"
                        defaultValue={null}
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <BaseDatePicker
                                {...field}
                                label="Date of Purchase"
                                onChange={(e: any) => {
                                    onChange(e)
                                }}
                                value={value}
                                fullWidth
                                inputRef={ref}
                                maxDate={new Date()}
                                disabled={isDisabled}
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    <Controller
                        control={control}
                        name="partSeller.address"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                label="Address"
                                className="reddit-input w-100"
                                variant="filled"
                                disabled={isDisabled}
                                onKeyPress={(e: any) =>
                                    CommonService.allowsInput(e, [
                                        'alphabet',
                                        'space',
                                        'numeric',
                                    ])
                                }
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    {/* file upload */}
                    <UploadFiles
                        style={{ height: '168px' }}
                        remove
                        fileChanged={(e: string) =>
                            fileChanged(e, 'PART_SELLER')
                        }
                        isLoading={watchPartSeller?.loading}
                        filename={watchPartSeller?.file?.name}
                        fileUrl={watchPartSeller?.file?.url}
                        removeAction={() => removeFileUpload('PART_SELLER')}
                    />
                </Grid>
                <Grid item sm={6} xs={12} className="pt-2">
                    <Controller
                        control={control}
                        name="partSeller.state"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <BaseCreatableSelect
                                className="mb-2"
                                value={value}
                                onChange={(event: any) => {
                                    onChange(event)
                                    handleSelectChange(event, 'STATE')
                                }}
                                options={states}
                                label="State"
                                fullWidth
                                disabled={isDisabled}
                            />
                        )}
                    />

                    <Controller
                        control={control}
                        name="partSeller.city"
                        defaultValue=""
                        // rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <BaseCreatableSelect
                                className="mb-2"
                                value={value}
                                onChange={onChange}
                                options={cities}
                                label="City"
                                fullWidth
                                disabled={isDisabled || !watchPartSeller?.state}
                            />
                        )}
                    />

                    <Controller
                        control={control}
                        name="partSeller.zipCode"
                        defaultValue=""
                        rules={{
                            minLength: 1,
                            maxLength: 5,
                        }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                label="Zip Code"
                                className="reddit-input w-100"
                                variant="filled"
                                error={errors?.partSeller?.zipCode && true}
                                disabled={isDisabled}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'partSeller.zipCode',
                                    'Zip Code',
                                    'Zip Code should be 1 to 5 digit'
                                )}
                            />
                        )}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

const mapStateToProps = (store: any) => {
    return {
        cities: store?.client.regrounds?.part_cities.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        states: store?.client.regrounds?.part_states.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        components: store?.client.classifications?.components,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    return {
        getStates: (params?: ICommonQuery) =>
            dispatch(
                RegroundAction.getReground(
                    'STATE',
                    RegroundTypes.PART_STATE,
                    params
                ) as any
            ),
        getCities: (params: any) =>
            dispatch(
                RegroundAction.getReground(
                    'CITY',
                    RegroundTypes.PART_CITY,
                    params
                ) as any
            ),
        getComponents: () =>
            dispatch(
                ClassificationAction.getClassifications(
                    EClassifications.COMPONENT
                ) as any
            ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PartsForm)
